import React from "react";
import Async from "react-select/lib/Async";
import { getStores } from "../../../backend/stores";

export default function() {
  const { storeSelect } = this.state;
  return (
    <div className="swap-container form">
      <label>Send To:</label>
      <Async
        value={storeSelect}
        loadOptions={getStores}
        onChange={this._selectStore}
      />
      <button disabled={!storeSelect.value} onClick={this._swap}>
        Swap
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-swap/view.js